export const mutations = {
  // Set a report (create or update)
  SET_REPORT(state, { orgId, report }) {
    if (!state.reports[orgId]) {
      state.reports[orgId] = {}
    }
    state.reports[orgId][report.report_uuid] = report
  },

  // Set active report
  SET_ACTIVE_REPORT(state, reportUuid) {
    state.activeReportUuid = reportUuid
  },

  // Set active version
  SET_ACTIVE_VERSION(state, version) {
    state.activeVersion = version
  },

  // Delete a report
  DELETE_REPORT(state, { orgId, reportUuid }) {
    if (state.reports[orgId]) {
      delete state.reports[orgId][reportUuid]
    }

    if (state.activeReportUuid === reportUuid) {
      state.activeReportUuid = null
      state.activeVersion = null
    }
  },

  // Clear all report data
  CLEAR_REPORT_DATA(state) {
    state.reports = {}
    state.activeReportUuid = null
    state.activeVersion = null
  }
}
